import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'
import {
  FETCH_NEW_HOME_MENUS_FILTER_REQUEST,
  FETCH_NEW_HOME_MENUS_FILTER_SUCCESS,
  FETCH_NEW_HOME_MENUS_FILTER_FAILURE,
} from 'actionTypes'

export const fetchNewHomeMenus =
  (title, ldap, description, token) => (dispatch) => {
    dispatch({ type: FETCH_NEW_HOME_MENUS_FILTER_REQUEST })
    return new Api(token, dispatch)
      .get(API_URL.NEW_HOME_MENUS, {
        title,
        ldap,
        description,
        tipShow: 2,
      })
      .then((response) => {
        dispatch({
          type: FETCH_NEW_HOME_MENUS_FILTER_SUCCESS,
          payload: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: FETCH_NEW_HOME_MENUS_FILTER_FAILURE,
          payload: error,
        })
      })
  }
